import { ScrollDispatcher } from '@angular/cdk/scrolling';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { AuthService } from 'app/auth/auth.service';
import { DashboardService } from 'app/dashboard/dashboard.service';
import { Subject } from 'rxjs';
import * as XLSX from 'xlsx';
import { BillingserviceService } from '../billingService.service';
@Component({
  selector: 'app-excel-recovery-manager',
  templateUrl: './excel-recovery-manager.component.html',
  styleUrls: ['./excel-recovery-manager.component.scss']
})
export class ExcelRecoveryManagerComponent implements OnInit {
  isExcelFile: boolean;
  excelArray: any = [];
  keys: string[];
  checkBillingdatacolor:any="";
  dataSheet = new Subject();
  @ViewChild('inputFile') inputFile: ElementRef;
  constructor(public dialog: MatDialog,
    public dashboardService: DashboardService,public authService: AuthService, public dialogRef: MatDialogRef<ExcelRecoveryManagerComponent>,public billingservice: BillingserviceService) { }

  ngOnInit(): void {
  }
  closedialog() {
    this.dialogRef.close(0);
  }

  // excel to json covertion 
  onFileChange(ev) {
    this.excelArray = [];
    let workBook = null;
    let jsonData = null;
    const reader = new FileReader();
    this.isExcelFile = ev.target.files[0].name.match(/(.xls|.xlsx)/);
    if (this.isExcelFile) {
      const file = ev.target.files[0];
      reader.onload = (event) => {
        const data = reader.result;
        workBook = XLSX.read(data, { type: 'binary' });
        jsonData = workBook.SheetNames.reduce((initial, name) => {
          const sheet = workBook.Sheets[name];
          initial[name] = XLSX.utils.sheet_to_json(sheet);
          return initial;
        }, {});
        var dataString = JSON.stringify(jsonData);
        //document.getElementById('output').innerHTML = dataString.slice(0, 300).concat("...");
        if (workBook.SheetNames.length > 0) {
          for (var i = 0; i < workBook.SheetNames.length; i++) {
            if (jsonData[workBook.SheetNames[i]].length > 0) {
              jsonData[workBook.SheetNames[i]].forEach(element => {
                this.excelArray.push(element);
              });
            }
          }
          this.checkBillingExitorNot(this.excelArray);
        }

      }
      reader.readAsBinaryString(file);
    } else {
      this.dashboardService.openSnackBar("FIle Format Is not Correct", "OK");
    }

  }
    checkExcelsheetdata:any=[];
  checkBillingExitorNot(excelArraydata:any){
   
    if(excelArraydata.length >0){
       this.checkExcelsheetdata =[];
      excelArraydata.forEach(item =>{
        try {
        this.billingservice.GetRecoveryManagerExcelSheetCheck(item.FK_BranchId,item.Fk_FinyearId, item.FK_BillSeriesID, item.BillNo).subscribe(data => {
          if(data.length>0){
            data.forEach(element => {
            //  element.displayFinYear[0] =this.authService.FinYears.filter(item=>item.pkFinYearId ==item.FK_FinYearId);
             if(element.netBalance >0){
              if( element.totalRecovered ==null){
                element.totalRecovered=0;
              }
              element.recoverAmount=item.RecoveryAmount;
              element.tds=item.TDS;
              element.discount=item.Discount;
              element.disAllow=item.Deduction;
              element.st=item.st;
              element.totalAmt =element.recoverAmount + element.tds + element.discount + element.disAllow + element.st;
              element.remarks=item.Remarks;
              this.checkExcelsheetdata.push(element);
             }
             
            });
          }
          console.log(this.checkExcelsheetdata);
        });
      }catch(error) {
        // handle error
    }
      });
     
    }
  }
 
  checkBillingcolor(billseriesid:any,billno:any){
  
    if(this.checkExcelsheetdata.length >0){
     var colordata= this.checkExcelsheetdata.filter(item=> item.billNo == billno && item.fK_BillSerieseId == billseriesid);
     if(colordata.length >0){
       return "rgb(10, 221, 21)";
     }else{
      return "Yellow";
     }
    }else{
      return "Yellow";
    }
  }
  // tranfer data to main recovery form
  transferData(){
    if(this.checkExcelsheetdata.length >0){
      this.dialogRef.close(this.checkExcelsheetdata);
    }else{
      this.dashboardService.openSnackBar("No data available please select excel file first", "OK");
    }
  }
  // removeData() {
  //   this.inputFile.nativeElement.value = '';
  //   this.dataSheet.next(null);
  //   this.keys = null;
  // }
}
